'use strict'

class FormService {
  constructor ($http) {
    this.$http = $http
  }

  validateForm (form) {
    form.formSent.$setValidity('formSent', true)
    if (!form.$invalid) { return true }
    form.formSent.$setValidity('formSent', false)
    alert.danger('Preencha os campos obrigatórios')
  }

  searchZipCode (zipCode) {
    return this.$http({
      method: 'GET',
      url: 'https://viacep.com.br/ws/' + zipCode + '/json/'
    })
  }
}

angular.module('app').service('formService', FormService)



//////////////////
// WEBPACK FOOTER
// ./services/form.service.js
// module id = 102
// module chunks = 0